module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_costumes@3x-5be92a8d66ec3df0e540a86f374c4474.webp";